import * as types from "./actions";
import APIUtil from "./../config/APIUtil";
import UrlConstants from "./../config/UrlConstants";
import * as code from "./../config/Constants";

/**
 *
 * @desc Get APP systemVersions
 */

export function getSystemVersionsAction(recordPerPage, pageIndex) {
  var url = UrlConstants.getSystemVersionsUrl.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  // if (searchKey) {
  //   replacedUrl = replacedUrl + "&searchKey=" + searchKey;
  // }
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response.status === code.OK) {
        return response;
      } else {
        return response;
      }
    });
  };
}

/**
 *
 * @desc Get Version details
 */

export function getSystemVersionDetailsAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.systemversionUrl + "/getVersionDetails?id=" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        return response;
      } else {
        return response;
      }
    });
  };
}

/**
 *
 * @desc Add New APP release
 */

export function addSystemVersionsAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.systemversionUrl + "/add",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        return response;
      } else {
        return response;
      }
    });
  };
}

// export function deleteSystemBannersAction(id) {
//   return function(dispatch) {
//     return APIUtil.deleteMethod(
//       UrlConstants.systemBannersUrl + "/" + id,
//       true
//     ).then((response) => {
//       if (response.status === code.OK) {
//         dispatch({
//           type: types.GET_SYSTEMBANNERS,
//           systemBanners: response.data,
//         });
//       } else {
//         dispatch({
//           type: types.GET_SYSTEMBANNERS,
//           systemBanners: [],
//         });
//       }

//       return response || [];
//     });
//   };
// }

export function editSystemVersionsAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.systemversionUrl + "/update?id=" + id,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        return response;
      } else {
        return response;
      }
    });
  };
}

export function updateSystemVersionStatusAction(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.systemversionUrl + "/activeInactive",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        return response;
      } else {
        return response;
      }
    });
  };
}

export function getCurrentSystemVersionAction() {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.systemversionUrl + "/getLatestVersion",
      true
    ).then((response) => {
      if (response.status === code.OK) {
        return response;
      } else {
        return [];
      }
    });
  };
}
